import { Events } from '@/utils/servicesEvents'
import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getStoreData(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest(data) {
  const url = `${urls.getStoreData}${data.id}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalStore(rawData)

    return {
      statusCode: 200,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getStoreData }
